import React from 'react';
import { UserEntity } from 'Models/Entities';
import { isNotNullOrUndefined } from 'Util/TypeGuards';
import { MessageBox } from 'Views/Components/_HumanWritten/MessageBox/MessageBox';

interface NewEmailUnverifiedBannerProps {
	user: UserEntity;
	/**
	 * Page-specific actions: the customer page offers Cancel-update; staff adds Resend. An element
	 * (not a bare ReactNode) because the information box always renders it into its button row.
	 */
	actions: JSX.Element;
}

/**
 * "New Email Address Unverified" — shown while a verified account has a pending email change.
 * Renders nothing otherwise, so pages can drop it into their banners slot unconditionally.
 */
export default function NewEmailUnverifiedBanner({ user, actions }: NewEmailUnverifiedBannerProps) {
	const hasPendingEmailChange =
		user.emailConfirmed && isNotNullOrUndefined(user.newEmailAddress) && user.newEmailAddress !== user.email;

	if (!hasPendingEmailChange) {
		return null;
	}

	return (
		<div className="pt-4">
			<MessageBox
				title="New Email Address Unverified"
				status="warning"
				actions={actions}
				slim
				testId="account-new-email-unverified-notice"
			>
				{
					<p>
						<strong>{user.newEmailAddress}</strong> is not verified. We will continue to send email
						communications to <strong>{user.email}</strong> in the meantime.
					</p>
				}
			</MessageBox>
		</div>
	);
}
